import { useTheme } from './useTheme';
import { hexToRGB } from '../../utils/colorConverter';
export const benefitColorSet = {
    mealVoucher: 'mealVoucher',
    gift: 'gift',
    mobility: 'mobility',
    wallet: 'wallet',
    cashback: 'cashback',
};
export const featureColorSet = {
    pot: 'pot',
    activity: 'activity',
    pulse: 'pulse',
    praise: 'praise',
    article: 'article',
};
export const coreColorSet = {
    critical: 'critical',
    warning: 'warning',
    success: 'success',
    default: 'default',
    contrast: 'contrast',
    primary: 'primary',
};
export const interactiveColorSet = {
    'interactive.primary': 'interactive.primary',
    'interactive.primary.hover': 'interactive.primary.hover',
    'interactive.primary.pressed': 'interactive.primary.pressed',
    'interactive.primary.disabled': 'interactive.primary.disabled',
    'interactive.secondary': 'interactive.secondary',
    'interactive.secondary.hover': 'interactive.secondary.hover',
    'interactive.secondary.pressed': 'interactive.secondary.pressed',
    'interactive.secondary.disabled': 'interactive.secondary.disabled',
    'interactive.text': 'interactive.text',
    'interactive.text.hover': 'interactive.text.hover',
    'interactive.text.pressed': 'interactive.text.pressed',
    'interactive.text.disabled': 'interactive.text.disabled',
    'interactive.critical': 'interactive.critical',
    'interactive.critical.hover': 'interactive.critical.hover',
    'interactive.critical.pressed': 'interactive.critical.pressed',
    'interactive.critical.disabled': 'interactive.critical.disabled',
    'interactive.contrast': 'interactive.contrast',
    'interactive.contrast.hover': 'interactive.contrast.hover',
    'interactive.contrast.pressed': 'interactive.contrast.pressed',
    'interactive.contrast.disabled': 'interactive.contrast.disabled',
};
const getBenefitColorSet = (colorSet) => {
    if (colorSet && Object.keys(benefitColorSet).includes(colorSet))
        return colorSet;
    return null;
};
const getFeatureColorSet = (colorSet) => {
    if (colorSet && Object.keys(featureColorSet).includes(colorSet))
        return colorSet;
    return null;
};
const getCoreColorSet = (colorSet) => {
    if (colorSet && Object.keys(coreColorSet).includes(colorSet))
        return colorSet;
    return null;
};
export const getInteractiveColorSet = (colorSet) => {
    if (colorSet && Object.keys(interactiveColorSet).includes(colorSet)) {
        const splitColor = colorSet.split('.');
        return {
            type: splitColor[1],
            status: splitColor[2] || null,
        };
    }
    return { type: null, status: null };
};
export const useColorSet = ({ colorSet, invertedColor }) => {
    const theme = useTheme();
    const benefitColorSet = getBenefitColorSet(colorSet);
    if (benefitColorSet) {
        return {
            background: invertedColor
                ? theme.colors.benefits[benefitColorSet].content.default
                : theme.colors.benefits[benefitColorSet].background.default,
            content: invertedColor
                ? theme.colors.benefits[benefitColorSet].background.default
                : theme.colors.benefits[benefitColorSet].content.default,
            border: invertedColor
                ? hexToRGB(theme.colors.content.default, 0.06)
                : theme.colors.benefits[benefitColorSet].background.selected,
        };
    }
    const featureColorSet = getFeatureColorSet(colorSet);
    if (featureColorSet) {
        return {
            background: invertedColor
                ? theme.colors.features[featureColorSet].content.default
                : theme.colors.features[featureColorSet].background.default,
            content: invertedColor
                ? theme.colors.features[featureColorSet].background.default
                : theme.colors.features[featureColorSet].content.default,
            border: invertedColor
                ? hexToRGB(theme.colors.content.default, 0.06)
                : theme.colors.features[featureColorSet].background.selected,
        };
    }
    const coreColorSet = getCoreColorSet(colorSet);
    if (coreColorSet) {
        return {
            background: invertedColor
                ? theme.colors.content[coreColorSet]
                : theme.colors.background[coreColorSet],
            content: invertedColor
                ? theme.colors.background[coreColorSet]
                : theme.colors.content[coreColorSet],
            border: invertedColor
                ? hexToRGB(theme.colors.content.default, 0.06)
                : theme.colors.border[coreColorSet],
        };
    }
    const interactiveColorSet = getInteractiveColorSet(colorSet);
    if (interactiveColorSet.type) {
        return {
            background: interactiveColorSet.status === 'disabled'
                ? theme.colors.background.contrast
                : theme.colors.interactive[interactiveColorSet.type][interactiveColorSet.status || 'default'],
            content: interactiveColorSet.status === 'disabled'
                ? theme.colors.content.disabled
                : theme.colors.content.above[interactiveColorSet.type],
            border: theme.colors.interactive[interactiveColorSet.type].pressed,
        };
    }
    return {
        background: invertedColor
            ? theme.colors.content.default
            : theme.colors.background.default,
        content: invertedColor
            ? theme.colors.background.default
            : theme.colors.content.default,
        border: invertedColor
            ? hexToRGB(theme.colors.content.default, 0.06)
            : theme.colors.border.default,
    };
};
